<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" class="tab-header">
    <portal to="layout-nav-title">{{$t('wechatMiniProgram.analysis.userPortrait')}}</portal>

    <el-select v-model="dataType">
      <el-option
        v-for="item in dataTypeOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select >

    <el-select v-model="timeRange" @change="timeRangeChange">
      <el-option
        v-for="item in timeRangeOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select >

    <el-tab-pane :label="$t('wechatMiniProgram.analysis.genderAndAge')" name="first">
      <PieEchart
        :title-text="$t('wechatMiniProgram.analysis.gender')"
        :options="defaultOptions"
        :data="data[dataType]['genders']"/>

      <PieEchart
        :title-text="$t('wechatMiniProgram.analysis.age')"
        :options="defaultOptions"
        :data="data[dataType]['ages']"/>
    </el-tab-pane>

    <!-- <el-tab-pane :label="$t('wechatMiniProgram.analysis.region')" name="second"> -->
      <!-- <CountryEchart -->
        <!-- :title-text="$t('wechatMiniProgram.analysis.province')" -->
        <!-- :seriesName="seriesName" -->
        <!-- :data="data[dataType]['province']"/> -->
      <!-- <ProvinceEchart -->
        <!-- style="margin-top: 60px;" -->
        <!-- :title-text="$t('wechatMiniProgram.analysis.city')" -->
        <!-- :seriesName="seriesName" -->
        <!-- :data="data[dataType]['city']"/> -->
    <!-- </el-tab-pane> -->

    <el-tab-pane :label="$t('wechatMiniProgram.analysis.platformAndDevice')" name="third">
      <PieEchart
        :title-text="$t('wechatMiniProgram.analysis.platform')"
        :options="defaultOptions"
        :data="data[dataType]['platforms']"/>
      <PieEchart
        :title-text="$t('wechatMiniProgram.analysis.device')"
        :options="defaultOptions"
        :data="data[dataType]['devices']"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import PieEchart from '@/components/echarts/pie-echart';
import CountryEchart from '@/components/echarts/country-echart';
import ProvinceEchart from '@/components/echarts/province-echart';
import _ from 'lodash';

@Component({
  components: {
    PieEchart,
    CountryEchart,
    ProvinceEchart
  }
})
export default class UserPortrait extends Vue {
  activeName = 'first';
  dataType = 'visit_uv_new';
  timeRange = 'latest_1_day';
  data = {
    visit_uv_new: {},
    visit_uv: {}
  }

  defaultOptions = {
    seriesName: this.seriesName,
    seriesRadius: '40%',
    seriesCenter: ['30%', '50%']
  }

  get seriesName() {
    return _.result(_.find(this.dataTypeOptions, (item) => item.value === this.dataType), 'label');
  }

  async timeRangeChange(value) {
    this.timeRange = value;
    this.data = await this.$request.get('/wechat_third_party_platform/data_analysis/user_portrait', { params: { range_kind: value } });
  }

  get dataTypeOptions() {
    return [
      {
        value: 'visit_uv_new',
        label: this.$t('wechatMiniProgram.analysis.portraitOfActiveUsers')
      },
      {
        value: 'visit_uv',
        label: this.$t('wechatMiniProgram.analysis.portraitOfNewUsers')
      }
    ]
  }

  get timeRangeOptions() {
    return [
      {
        value: 'latest_1_day',
        label: this.$t('wechatMiniProgram.analysis.yesterday')
      },
      {
        value: 'latest_7_day',
        label: this.$t('wechatMiniProgram.analysis.latest7Day')
      },
      {
        value: 'latest_30_day',
        label: this.$t('wechatMiniProgram.analysis.latest30Day')
      }
    ]
  }

  async mounted() {
    this.data = await this.$request.get('/wechat_third_party_platform/data_analysis/user_portrait');
  }
}

export const route = [
  {
    path: '/user_portrait',
    name: 'user_portrait',
    component: UserPortrait,
    meta: {
      can: 'data_analyses.user_portrait'
    }
  }
]
</script>

<style lang="scss" scoped>
  .tab-header {
    margin-left: 15px;
  }
  .el-select {
    margin-right: 20px;
  }
</style>
